import * as React from 'react';
import { App, ProviderProps as AppProps } from 'oasis-os-react';
import { getParam, setupFocusDetection } from 'oasis-os-utils';
import { StoreProvider } from 'oasis-os-common';
import { ContentfulProvider, ProviderProps as ContentfulProps } from 'oasis-os-contentful';
import { AuthProvider, AuthSubProvider, AuthInterimProvider } from 'oasis-auth';
import Viewport from '../components/Viewport';
import { Spinner } from 'oasis-os-common';

import '../theme/global.css';

setupFocusDetection();
interface FeatureAppProps extends AppProps {
  id?: ContentfulProps['id'];
}

const ENTRY_ID = process.env.CONTENTFUL_ENTRY_ID ?? getParam('entryId') ?? 'ZYKVTU71CQS6ROZDNydgk';
const IS_HYBRID = process.env.IS_HYBRID ?? getParam('isHybrid') ?? false;
const additionalProviderConfig = {
  releaseId: process.env.CONTENTFUL_RELEASE_ID ?? getParam('releaseId') ?? '2YADvVe0XixiF7xK9emMTg',
  domainName:
    process.env.DOMAIN_NAME ??
    getParam('domainName') ??
    'pwa-features.dev.wlpc.cloud.synchronoss.net',
  localApps: process.env.LOCAL_APPS ?? getParam('localApps') ?? '',
  isHybrid: IS_HYBRID && IS_HYBRID === 'true',
  localAppConfig: null,
  contentfulEnv: process.env.CONTENTFUL_ENVIRONMENT,
};
const spinnerSrc = 'assets/loader/wl-icon-progress.svg';
// TODO - commenting becuase of WLPWA-11827, consider it when we focus on hybrid

// // Read the contentful config from local file for hybrid apps
// if (additionalProviderConfig.isHybrid) {
//   try {
//     // eslint-disable-next-line import/no-dynamic-require, global-require
//     additionalProviderConfig.localAppConfig = require(`../../${ENTRY_ID}.json`);
//   } catch (appError) {
//     // eslint-disable-next-line no-console
//     console.log(
//       'Something went wrong while loading the local contentful application config: ',
//       appError,
//     );
//   }
// }

const FeatureApp: React.FC<FeatureAppProps> = ({ id = ENTRY_ID }: FeatureAppProps) => (
  <App id="root" app={{ name: 'pwa' }}>
    {(
      <Spinner position={'center'} spinnerSrc={spinnerSrc} show={true} />
    )}
    <StoreProvider>
      <ContentfulProvider
        id={id}
        query={{ include: 10 }}
        additionalConfig={additionalProviderConfig}
      >
        <AuthProvider>
          <AuthSubProvider>
            <AuthInterimProvider>
              <Viewport />
            </AuthInterimProvider>
          </AuthSubProvider>
        </AuthProvider>
      </ContentfulProvider>
    </StoreProvider>
  </App>
);

export default FeatureApp;
